import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.bestsalescoach.ai";
const DEFAULT_IMAGE = `${SITE_URL}/bestsalescoach-logo.jpg`;

function ensureMeta(selector, attributeName, attributeValue) {
  const existing =
    document.head.querySelector(selector) ||
    (() => {
      const node = document.createElement("meta");
      node.setAttribute(attributeName, attributeValue);
      document.head.appendChild(node);
      return node;
    })();

  existing.setAttribute(attributeName, attributeValue);
  return existing;
}

function ensureLink(selector, relValue) {
  const existing =
    document.head.querySelector(selector) ||
    (() => {
      const node = document.createElement("link");
      node.setAttribute("rel", relValue);
      document.head.appendChild(node);
      return node;
    })();

  existing.setAttribute("rel", relValue);
  return existing;
}

const PageMeta = ({
  title,
  description,
  canonicalPath,
  ogType = "website",
  image = DEFAULT_IMAGE,
}) => {
  const location = useLocation();

  useEffect(() => {
    const resolvedPath = canonicalPath || location.pathname || "/";
    const canonicalUrl = new URL(resolvedPath, SITE_URL).toString();

    if (title) {
      document.title = title;
    }

    if (description) {
      ensureMeta('meta[name="description"]', "name", "description").setAttribute(
        "content",
        description
      );
    }

    ensureLink('link[rel="canonical"]', "canonical").setAttribute("href", canonicalUrl);

    ensureMeta('meta[property="og:title"]', "property", "og:title").setAttribute(
      "content",
      title || document.title
    );
    ensureMeta(
      'meta[property="og:description"]',
      "property",
      "og:description"
    ).setAttribute("content", description || "");
    ensureMeta('meta[property="og:type"]', "property", "og:type").setAttribute(
      "content",
      ogType
    );
    ensureMeta('meta[property="og:url"]', "property", "og:url").setAttribute(
      "content",
      canonicalUrl
    );
    ensureMeta('meta[property="og:image"]', "property", "og:image").setAttribute(
      "content",
      image
    );

    ensureMeta('meta[name="twitter:card"]', "name", "twitter:card").setAttribute(
      "content",
      "summary_large_image"
    );
    ensureMeta('meta[name="twitter:title"]', "name", "twitter:title").setAttribute(
      "content",
      title || document.title
    );
    ensureMeta(
      'meta[name="twitter:description"]',
      "name",
      "twitter:description"
    ).setAttribute("content", description || "");
    ensureMeta('meta[name="twitter:image"]', "name", "twitter:image").setAttribute(
      "content",
      image
    );
  }, [canonicalPath, description, image, location.pathname, ogType, title]);

  return null;
};

export default PageMeta;
